import { render } from "./WhatsAppTutorialView.vue?vue&type=template&id=17044a1d&scoped=true"
import script from "./WhatsAppTutorialView.vue?vue&type=script&lang=js"
export * from "./WhatsAppTutorialView.vue?vue&type=script&lang=js"

import "./WhatsAppTutorialView.vue?vue&type=style&index=0&id=17044a1d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17044a1d"]])

export default __exports__